<template>
  <div class="p-login">
    <Head title="湖南省小额贷款公司经营数据填报系统" />
    <div class="login-main">
      <div class="login-title">
        <img src="../../assets/login-page-title.png" alt="" />
      </div>
      <div class="login-box">
        <div class="input-box">
          <div class="input">
            <img class="icon" src="../../assets/login-icon-account.png" alt="" />
            <input
              v-model="form.username" type="text" placeholder="用户名/邮箱/手机号" @blur="inputBlur('clear1')"
              @focus="display.clear1=true"
            />
            <img
              v-show="display.clear1" class="clear" src="../../assets/login-icon-clear.png" alt=""
              @click="form.username=&quot;&quot;"
            />
          </div>
          <div class="input">
            <img class="icon" src="../../assets/login-icon-psw.png" alt="" />
            <input
              v-model="form.password" type="password" placeholder="密码" @blur="inputBlur('clear2')"
              @focus="display.clear2=true"
              autocomplete="new-password"
            />
            <img
              v-show="display.clear2" class="clear" src="../../assets/login-icon-clear.png" alt=""
              @click="form.password=&quot;&quot;"
            />
          </div>
          <!--          <div class="ver-input">-->
          <!--            <div class="left">-->
          <!--              <img class="icon" src="../../assets/login-icon-check.png" alt="" />-->
          <!--              <input-->
          <!--                v-model="form.verifyCode" type="text" placeholder="验证码" @blur="inputBlur('clear3')"-->
          <!--                @focus="display.clear3=true"-->
          <!--              />-->
          <!--              <img-->
          <!--                v-show="display.clear3" class="clear" src="../../assets/login-icon-clear.png" alt=""-->
          <!--                @click="form.verifyCode=&quot;&quot;"-->
          <!--              />-->
          <!--            </div>-->
          <!--            <div class="right">-->
          <!--              <img src="../../assets/login-input-3.png" alt="" />-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div class="login-btn" @click="login()">登录</div>
        <div class="login-bot">
          <div class="left" @click="form.remember=!form.remember">
            <div class="radio"><span v-show="form.remember" /></div>
            记住密码
          </div>
        </div>
      </div>
    </div>
    <div class="login-copy">
      &copy; {{ formatYear() }} 湖南省地方金融管理局
    </div>
  </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue'

export default {
  components: {
    Head,
  },
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        username: '',
        password: '',
        remember: false,
      }),
      display: {
        clear1: false,
        clear2: false,
        clear3: false,
      },
    }
  },
  watch: {
    errors: {
      deep: true,
      handler(val) {
        if (Object.keys(val).includes('username')) {
          this.$message.error(val.username)
        }
      },
    },
  },
  created() {
    this.$notify({
      title: '提示',
      message: '如您忘记密码，需人工重置，请您联系湖南省小额贷款公司协会0731-89855217',
      duration: 0
    });
  },
  methods: {
    login() {
      if (!this.form.username || !this.form.password) {
        this.$message.error('请输入用户名密码')
        return
      }
      this.form.post('/login')
    },
    formatYear() {
      let date = new Date()
      return date.getFullYear()
    },
    inputBlur(index) {
      window.setTimeout(() => {
        this.display[index] = false
      }, 100)
    },
  },
}
</script>

<style lang="stylus" scoped>
.p-login
  background: #003FD2 url(../../assets/login-page-bg.png) no-repeat center
  width: 100%
  height: 100%
  background-size: 100% 100%
  position: relative
  font-size: 12px
  color #fff

  .login-main
    width: 474.67px
    margin: 0 auto
    position: absolute
    left: 50%
    margin-left: -237.33px
    top 50%
    margin-top: -340px

    display: flex;
    flex-direction: column;
    align-items: center;

    .login-title
      text-align: center

      margin-top: 60px

      img
        width: 615.67px

    .login-box
      width: 356px
      height: 356px
      background-size: 100% 100%
      background-image: url(../../assets/login-box-bg.png)
      margin-top: 50px
      box-sizing: border-box
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center

      .input-box
        display: flex
        flex-direction: column

        .input, .ver-input
          width: 300px
          height: 38px
          background-size: 100% 100%
          background-image: url(../../assets/login-input-1.png)
          display: flex
          flex-direction: row
          align-items: center
          margin-top: 17.3px
          box-sizing: border-box
          padding: 0 11px

          input
            width: 280px
            padding: 10px 0
            background: none
            border: 0
            font-size: 14px

          img
            width: 22px

          .icon
            margin-right: 20px

          .clear
            margin-left: auto

        .ver-input
          background: none
          padding: 0

          .left
            width: 224px
            height: 51px
            background-size: 100% 100%
            background: url(../../assets/login-input-2.png) no-repeat center
            display: flex
            flex-direction: row
            align-items: center
            box-sizing: border-box
            padding-left: 11px

            input
              width: 110px

            .clear
              margin-left: 10px

          .right
            margin-left: auto

            img
              width: 160px

      .login-btn
        width: 300px
        height: 38x
        background-size: 100% 100%
        background-image: url(../../assets/login-btn-bg.png)
        text-align: center
        font-size: 16px
        margin-top: 50px
        cursor pointer
        line-height: 38px


      .login-bot
        width 400px
        display: flex
        flex-direction: row
        justify-content: space-between
        margin-top: 10px
        margin-left: 100px
        color #FFF

        .left
          display: flex
          flex-direction: row
          align-items: center
          cursor: pointer

          .radio
            width: 14px
            height: 14px
            background-color: #fff
            border-radius: 100%
            display: flex
            justify-content: center
            align-items: center
            margin-right: 6px
            font-size: 12px

            span
              display: block
              width: 10px
              height: 10px
              border-radius: 100%
              background-color: #FF9400

        .right
          cursor pointer

  .login-copy
    width: 100%
    text-align: center
    position: absolute
    bottom: 30px

:-moz-placeholder
  color: #fff;
  opacity: .45;
  font-size: 14px;
  font-weight: normal;

::-moz-placeholder
  color: #fff;
  opacity: .45;
  font-size: 14px;
  font-weight: normal;

input:-ms-input-placeholder, textarea:-ms-input-placeholder
  color: #fff;
  opacity: .45;
  font-size: 14px;
  font-weight: normal;

input::-webkit-input-placeholder, textarea::-webkit-input-placeholder
  color: #fff;
  opacity: .45;
  font-size: 14px;
  font-weight: normal;

</style>
